import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, orderBatchesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, orderBatchesActions);

export default slice.reducer;
